import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatFormFieldControl} from "@angular/material/form-field";
import {Subject} from "rxjs";

const debug = initDebugger('MatFormFieldControlProxy');

/** {@link MatFormFieldControl} implementasjon som delegerer alle kall videre til en annen matFormFieldControl instans.
 *
 * Forenkler implementasjon av komponent som kun omslutter en annen matFormFieldControl instans, og der denne komponenten
 * skal kunne brukes som barn av <mat-form-field> */
export class MatFormFieldControlProxy<T> implements MatFormFieldControl<T> {

    constructor(private matFormFieldControl: () => MatFormFieldControl<T> | null, stateChanges: Subject<void>) {
        this.stateChanges = stateChanges;
    }

    //MatFormFieldControl impl

    readonly stateChanges: Subject<void>;

    get placeholder() {
        return this.matFormFieldControl()?.placeholder ?? '';
    }

    get controlType() {
        return this.matFormFieldControl()?.controlType;
    }

    get disabled() {
        return this.matFormFieldControl()?.disabled ?? false;
    }

    get empty() {
        return this.matFormFieldControl()?.empty ?? true;
    }

    get errorState() {
        return this.matFormFieldControl()?.errorState ?? false;
    }

    get focused() {
        return this.matFormFieldControl()?.focused ?? false;
    }

    get id() {
        return this.matFormFieldControl()?.id ?? '';
    }

    get ngControl() {
        return this.matFormFieldControl()?.ngControl ?? null;
    }

    //får feil når event types som MouseEvent..
    onContainerClick(event: any): void {
        this.matFormFieldControl()?.onContainerClick(event);
    }

    get required() {
        return this.matFormFieldControl()?.required ?? false;
    }

    setDescribedByIds(ids: string[]): void {
        this.matFormFieldControl()?.setDescribedByIds(ids);
    }

    get shouldLabelFloat() {
        return this.matFormFieldControl()?.shouldLabelFloat ?? false;
    }

    get userAriaDescribedBy() {
        return this.matFormFieldControl()?.userAriaDescribedBy;
    }

    get value() {
        return this.matFormFieldControl()?.value ?? null;
    }

    set value(value: T | null) {
        this.matFormFieldControl()!.value = value;
    }


    //hjelpemetoder
}

